<template>
  <v-menu
    v-model="menu"
    :nudge-bottom="12"
    min-width="240"
    offset-y
    transition="slide-y-transition"
    content-class="user-menu-popover"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        text
        dark
        class="user-btn px-2 ml-2"
        :class="{ 'active-btn': menu }"
      >
        <v-avatar size="32" class="mr-2 avatar-border">
          <v-icon>mdi-account-circle</v-icon>
        </v-avatar>

        <span
          class="d-none d-md-inline font-weight-bold text-body-2 white--text"
        >
          {{ user.username }}
        </span>

        <v-icon right small class="ml-1 opacity-6">
          {{ menu ? "mdi-chevron-up" : "mdi-chevron-down" }}
        </v-icon>
      </v-btn>
    </template>

    <v-card class="user-card">
      <v-list class="pb-0">
        <v-list-item class="px-4 py-2">
          <v-list-item-avatar size="48" class="mr-4">
            <v-avatar class="elevation-0 border-avatar" size="48">
              <span class="white--text text-h6 font-weight-light">
                {{ user.username.charAt(0).toUpperCase() }}
              </span>
            </v-avatar>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title
              class="font-weight-black text-h6 primary-dark--text"
            >
              {{ user.username }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider class="mx-4 opacity-1"></v-divider>

      <v-list dense class="py-2">
        <v-list-item @click="" class="menu-item mx-2 rounded-lg">
          <v-list-item-icon class="mr-3">
            <v-icon small>mdi-card-account-details-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="font-weight-medium"
            >Mis Datos</v-list-item-title
          >
        </v-list-item>

        <v-list-item @click="" class="menu-item mx-2 rounded-lg">
          <v-list-item-icon class="mr-3">
            <v-icon small>mdi-chart-pie</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="font-weight-medium"
            >Mis Consumos</v-list-item-title
          >
        </v-list-item>

        <v-list-item @click="" class="menu-item mx-2 rounded-lg">
          <v-list-item-icon class="mr-3">
            <v-icon small>mdi-cash-refund</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="font-weight-medium"
            >Mis Retiros</v-list-item-title
          >
        </v-list-item>

        <v-divider class="my-2 mx-4"></v-divider>

        <v-list-item @click="logout" class="mx-2 rounded-lg">
          <v-list-item-icon class="mr-3">
            <v-icon small>mdi-logout-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="font-weight-bold"
            >Cerrar Sesión</v-list-item-title
          >
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  name: "usuario.menu",
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  methods: {
    ...mapActions("auth", ["logOut"]),
    async logout() {
      await this.logOut();
    },
  },
};
</script>



<style lang="scss" scoped>
// Botón Activador
.user-btn {
  text-transform: none !important;
  letter-spacing: 0;
  border-radius: 12px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
  }
}

.active-btn {
  background: rgba(186, 107, 48, 0.15) !important;
}

.avatar-border {
  border: 1px solid rgba(186, 107, 48, 0.4);
}
.border-avatar {
  /* Usamos tu color BA6B30 con un grosor de 2px */
  border: 2px solid #ba6b30 !important;
  background-color: transparent !important;
}

// Card de Menú
.user-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.menu-item {
  transition: all 0.2s ease;
  &:hover {
    background-color: rgba(186, 107, 48, 0.05) !important;
    color: #ba6b30 !important;
    .v-icon {
      color: #ba6b30 !important;
    }
  }
}

.logout-item {
  transition: all 0.2s ease;
  &:hover {
    background-color: #fff5f5 !important;
  }
}

.opacity-6 {
  opacity: 0.6;
}
.opacity-1 {
  opacity: 0.1;
}

// Sombra personalizada para el Popover
::v-deep .user-menu-popover {
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}
</style>
